import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthFailure = () => {
	return (
		<Navigate to="/auth/login?error=Login%20was%20unsuccessful" />
	);
};

export default AuthFailure;